module.exports = __webpack_public_path__ + "img/dsci0085.ca95f0c1.jpg";